export default __webpack_public_path__ + "static/media/Established.079d0270.svg";